/**
 * Makes a best guess of what the user's locale might be.
 *
 * Useful if messages and dates need to be formatted to a specific locale
 * */
export const getCurrentLocale = () => {
  const { navigator } = window;

  // does it use the new NavigatorLanguage spec
  return navigator.languages
    ? navigator.languages[0]
    : navigator.language || navigator.userLanguage;
};
